import { STORAGE_KEY } from '@/constants/storage';
import { setUserLocale } from '@/services/user.service';

export default {
    methods: {
        switchLocale(locale) {
            if (locale !== this.$i18n.locale) {
                setUserLocale(locale).then(() => {
                    this.$cookies.set(
                        STORAGE_KEY.LOCALE,
                        locale,
                        Infinity,
                        null,
                        '.' + process.env.VUE_APP_DOMAIN
                    );
                    this.$i18n.locale = locale;
                    void this.$store.dispatch('auth/fetchUser');
                });
            }
        },
    },
};
